import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { isEqual } from 'lodash-es';
import { Subject } from 'rxjs';
import { map, takeUntil } from "rxjs/operators";
import { MediaFile } from 'src/app/models/media.model';
import { getAvailableOptionValues, ProductOption, ProductVariant, selectDefaultVariant } from 'src/app/shared-lib/domains/product';
import { FileDbService } from "../../../shared/a2-files/services/file-db.service";

@Component({
  selector: 'app-product-variants',
  templateUrl: './product-variants.component.html',
  styleUrls: ['./product-variants.component.scss'],
  standalone: false
})
export class ProductVariantsComponent implements OnInit {
  @Input() options: Array<ProductOption>;
  @Input() variants: Array<ProductVariant>;
  @Input() selected: ProductVariant;
  @Input() product;
  @Input() galleries;
  @Input() isProductCard: boolean = false;
  @Input() backSubject: Subject<void>;
  private destroy$ = new Subject<void>();
  @Output() changes = new EventEmitter<any>();
  optionsSelected: Array<String> = [];
  _variantSelected: ProductVariant = null;
  available: Array<any> = [];

  galleryImages$;

  step: number = 0;

  constructor(private fileDbService: FileDbService) {
  }

  ngOnInit() {

    this.backSubject?.pipe(takeUntil(this.destroy$)).subscribe(() => {
      --this.step;
    });

    this.galleryImages$ = this.fileDbService.getAll$(`products/${this.product.id}/files`).pipe(
      map(files => {
        this.galleries = {};
        const addGallery = (name, fileIds) => {
          this.galleries[name] = files
            .filter(file => fileIds.includes(file.id))
            .sort((a, b) => fileIds.indexOf(a.id) - fileIds.indexOf(b.id))
            .map(mediaFile => ({
              small: MediaFile.addNameSuffix(mediaFile.url, 's'),
              medium: MediaFile.addNameSuffix(mediaFile.url, 'm'),
              big: MediaFile.addNameSuffix(mediaFile.url, 'l'),
            }));
        };
        addGallery('Principal', this.product.mediaFiles);
        const variantGalleries = this.product.options[0]?.galleries;
        variantGalleries?.forEach(gal => {
          addGallery(gal.name, gal.gallery);
        });
        return this.galleries;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected) {
      const selected = changes.selected.currentValue;
      if (selected) {
        this.optionsSelected = [...selected.optionsValue];
      }
      if (changes.selected.isFirstChange()) {
        this.setAvailableOptions(0);
      }
    }
  }

  onChanges(i, event) {
    this.optionsSelected[i] = event.option;
    this.setSelected();
    this.setAvailableOptions(i);
  }

  nextStep() {
    if (this.step < this.options.length) {
      ++this.step;
      this.changes.emit({ step: this.step });
    }
  }

  setSelected() {
    this._variantSelected = { ...this.variants.find(variant => isEqual(variant.optionsValue, this.optionsSelected)) };
    this.changes.emit({ variant: this._variantSelected });
  }

  //TODO mejorar la lógica de disponibilidad
  setAvailableOptions(optionIndex) {
    this.available = getAvailableOptionValues(this.variants, this.options.length);
  }

  selectDefaultVariant() {
    if (!this.isProductCard) {
      const chosen = selectDefaultVariant(this.variants);
      if (chosen) {
        this.optionsSelected = [...chosen.optionsValue];
        this.setSelected();
        return;
      }
    }
    const fallback = this.variants.find(v => v.visible !== false);
    if (fallback) {
      this.optionsSelected = [...fallback.optionsValue];
      this.setSelected();
    }
  }
}

